import React from 'react';

import Plot from 'react-plotly.js';
import { usePunteggi } from '../reducers';
import { Evento } from '../api/types';

type PunteggiStoria = ReturnType<typeof usePunteggi>
type Classifica = PunteggiStoria["states"][0]["classifica"]

interface IProps {
  evento: Evento,
  classifica: Classifica
}


const IstogrammaPunteggi = (props: IProps) => {
  const { evento, classifica } = props;
  if (evento) {
    const adesso = new Date();
    const inizio = new Date(evento.inizio);
    if (inizio > adesso) {
      return <p>{"L'evento non è ancora iniziato."}</p>;
    }
  }

  const p = classifica.map(val => val.totale);

  return (
    <Plot
      data={[{
        x: p,
        type: "histogram",
      }]}
      layout={{
        title: "Punteggio",
        autosize: true,
        margin: { l: 200 },
        xaxis: { title: "Punteggio" },
        yaxis: { title: "Occorrenze" },
      }}
      style={{ width: "100%", height: "100%", minHeight: "600px" }}
    />
  )
}

export default IstogrammaPunteggi;
